module.exports = __webpack_public_path__ + "img/target.edc88608.svg";